import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Număr de telefon',
      placeholder: 'Introdu numărul de telefon',
    },
    email: {
      label: 'Adresă de email',
      placeholder: 'Introdu adresa de email',
    },
  },
  channel_chooser: {
    title: 'Trimite codul prin',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Gratuit, livrare rapidă',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Mesaj text standard',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'Email',
      subtitle: 'Codul direct în inbox',
    },
  },
  otp: {
    title: 'Introdu codul de verificare',
    send_code: 'Trimite codul',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Trimis prin <strong>WhatsApp</strong> la <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Trimis prin <strong>SMS</strong> la <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Trimis prin <strong>e-mail</strong> la <strong>{{phone}}</strong>',
    },
    sent_to: 'Trimis la',
    resend: {
      title: 'Nu ai primit codul?',
      countdown: 'Retrimite în',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Nu ai primit codul prin e-mail?',
          button: 'Retrimite prin email',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Nu ai primit codul?',
          button: 'Retrimite prin SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Nu ai primit codul?',
          button: 'Retrimite prin WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Trimite prin SMS',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Trimite prin WhatsApp',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Un mesaj cu codul de verificare a fost trimis pe telefonul tău. Introdu codul pentru a continua.',
      [OTP_DELIVERY_CHANNELS.EMAIL]:
        'Te rugăm să introduci codul trimis la această adresă: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Un mesaj WhatsApp cu codul de verificare a fost trimis pe telefonul tău. Introdu codul pentru a continua.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Sfat: Verifică inbox-ul și folderul de spam.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Atenție — codul este trimis de <strong>{{sender}}</strong>, partenerul nostru tehnologic.',
    business_account: 'Cont de business',
    message: '<strong>123456</strong> este codul tău de verificare. Pentru securitatea ta, nu îl distribui nimănui.',
  },
  error_messages: {
    frequent_requests:
      'Verifică mesajele. Am trimis deja codul la numărul indicat. Dacă nu l-ai primit, verifică numărul de telefon sau încearcă din nou în 10 minute.',
    frequent_requests_email:
      'Te rugăm să verifici inboxul și folderul de spam. Am trimis deja codul la acea adresă. Dacă nu a ajuns, încearcă din nou peste 10 minute.',
    invalid_number: 'Număr invalid. Te rugăm să încerci din nou.',
    invalid_email: 'Nu am putut trimite codul la acea adresă de email. Te rugăm să o verifici și să încerci din nou.',
    email_not_on_file:
      'Acest număr de telefon are deja un cont fără adresă de e-mail. Contactează {{support_email}} pentru a adăuga una — până atunci nu putem trimite coduri pentru acest număr prin e-mail.',
    turnstile_required: 'Te rugăm să finalizezi verificarea înainte de a solicita un cod nou.',
    generic_error: 'Hopa, ceva a mers greșit. Reîncarcă pagina și încearcă din nou.',
    change_phone_number_unsuccessful: 'Schimbarea numărului de telefon a eșuat. Te rugăm să încerci din nou.',
  },
  toasts: {
    code_sent: 'Cod trimis',
  },
};
